import React, { useEffect } from "react";
import { FaTimes, FaUserPlus } from "react-icons/fa";

const getTitle = (mode, adherent) => {
  if (mode === "create") return "Créer un adhérent";
  if (mode === "edit") return "Modifier l'adhérent";
  if (mode === "details") {
    return `${adherent?.prenom || ""} ${adherent?.nom || ""}`.trim() || "Fiche adhérent";
  }

  return "Adhérent";
};

const getSubtitle = (mode) => {
  if (mode === "create") {
    return "Ajoutez un adhérent directement dans un groupe du club.";
  }

  if (mode === "edit") {
    return "Mettez à jour les informations administratives et sportives.";
  }

  return "Consultez les informations détaillées de l'adhérent.";
};

export default function AdherentDrawer({
  open,
  mode,
  adherent,
  onClose,
  children,
}) {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-slate-950/50 backdrop-blur-sm transition-opacity ${
          open
            ? "pointer-events-auto opacity-100"
            : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
      />

      <aside
        className={`fixed inset-y-0 right-0 z-50 flex w-full max-w-3xl flex-col border-l border-slate-200 bg-white shadow-2xl transition-transform duration-300 dark:border-slate-800 dark:bg-slate-950 ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <header className="border-b border-slate-200 bg-slate-50 px-5 py-5 dark:border-slate-800 dark:bg-slate-900">
          <div className="flex items-start justify-between gap-4">
            <div className="flex min-w-0 gap-3">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300">
                <FaUserPlus />
              </span>

              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600 dark:text-orange-300">
                  Inscriptions
                </p>
                <h2 className="mt-1 truncate text-xl font-bold text-slate-950 dark:text-white">
                  {getTitle(mode, adherent)}
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  {getSubtitle(mode)}
                </p>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl border border-slate-200 bg-white text-slate-500 transition hover:border-rose-200 hover:text-rose-600 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300"
            >
              <FaTimes />
            </button>
          </div>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-5">
          {children}
        </div>
      </aside>
    </>
  );
}